import { asciiTextValidation } from 'framework/form';

// eslint-disable-next-line import/prefer-default-export
export const projectValidation = {
  resourcesData: {
    type: 'object',
    properties: {
      externalResources: {
        type: 'array',
        forEach: {
          type: 'object',
          properties: {
            name: {
              type: 'string',
              required: true,
              maxSize: 255,
              ...asciiTextValidation,
            },
            value: {
              type: 'string',
              link: true,
              required: true,
              maxSize: 255,
              ...asciiTextValidation,
            },
          },
        },
      },
    },
  },
};
export const projectUpdatePartialInfoValidation = {
  ...projectValidation,
  settings: {
    type: 'object',
    properties: {
      reportSettings: {
        type: 'object',
        required: true,
        properties: {
          reportFrequency: {
            type: 'string',
            required: true,
          },
          isSystemReportUsed: {
            type: 'string',
            required: true,
          },
        },
      },
    },
  },
};

export const projectUpdateFullInfoValidation = {
  ...projectValidation,
  projectDimension: {
    type: 'object',
    properties: {
      engagementType: {
        type: 'string',
        required: true,
      },
    },
  },
  sensitiveData: {
    type: 'object',
    properties: {
      originalName: {
        type: 'string',
        required: true,
        maxSize: 255,
        ...asciiTextValidation,
      },
    },
  },
  name: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  settings: {
    type: 'object',
    properties: {
      reportSettings: {
        type: 'object',
        required: true,
        properties: {
          reportFrequency: {
            type: 'string',
            required: true,
          },
          isSystemReportUsed: {
            type: 'string',
            required: true,
          },
          approvalType: {
            type: 'string',
            required: {
              value: true,
              when: {
                '$settings.reportSettings.isSystemReportUsed': {
                  ne: 'false',
                },
              },
            },
          },
        },
      },
    },
  },
};

export const commercialStateValidation = {
  projectDimension: {
    commercialState: {
      type: 'string',
      required: true,
    },
  },
};

export const progressValidation = {
  forecast: {
    type: 'object',
    properties: {
      plannedProgress: {
        type: 'string',
        required: true,
      },
      actualProgress: {
        type: 'string',
        required: true,
      },
    },
  },
};

export const completionBudgetHours = {
  forecast: {
    type: 'object',
    properties: {
      forecastCompletionBudgetHours: {
        type: 'string',
        required: true,
      },
    },
  },
};

export const forecastCompletionDateValidation = {
  forecast: {
    type: 'object',
    properties: {
      forecastCompletionDate: {
        type: 'string',
        required: true,
      },
    },
  },
};
